// extracted by mini-css-extract-plugin
export var icon = "_92-3";
export var subtitle = "_92-2";
export var title = "_92-1";
export var value = "_92-0";